import validator from "validator";
import zipcelx from "zipcelx";

import moment from "moment";
import Papa from "papaparse";
import i18n from "i18next";

const COLUMN_KEYS = {
  EMAIL: "EMAIL",
  ORDER_NUMBER: "ORDER_NUMBER",
  NAME: "NAME",
  SURNAME: "SURNAME",
  LANGUAGE: "LANGUAGE",
  REVIEW_ITEM: "REVIEW_ITEM",
};

export function prepareColumnMapping(lng) {
  const t = i18n.getFixedT(String(lng).toUpperCase()); // Get translator function for specific language
  const columnMapping = {};

  Object.keys(COLUMN_KEYS).forEach(key => {
    // Use the translation function for the CSV's language to get the column name
    columnMapping[key] = t(`csv.${key}`);
  });

  return columnMapping;
}


const languagesToString = (languages) => {
  if (!languages.length) return "";
  let tmp = " (";
  languages.forEach((lng) => {
    tmp += lng + ", ";
  });
  tmp = tmp.slice(0, -2);
  tmp += ")";
  return tmp;
};

export const downloadInvitationTemplate = (vendorLanguages, t) => {
  let data = [];
  data.push({ value: t("csv.NAME"), type: "string" });
  data.push({ value: t("csv.SURNAME"), type: "string" });
  data.push({ value: t("csv.EMAIL"), type: "string" });
  data.push({ value: t("csv.REVIEW_ITEM"), type: "string" });
  data.push({ value: t("csv.ORDER_NUMBER"), type: "string" });
  data.push({ value: t("csv.LANGUAGE")+ ' '+languagesToString(vendorLanguages), type: "string" });

  let xlsxFile = {
    filename: t("csv.invs"),
    sheet: {
      data: [data],
    },
  };
  zipcelx(xlsxFile);
};

export const downloadProfilesAndProductsList = (groups, vendorProfiles, products, vendor, languages, t, lng, selectTextByLanguage) => {
  
  let data = [];


  let line = [];
  line.push({ value: t("csv.elTitle") + " " + vendor.name, type: "string" });
  data.push(line);

  line = [];
  line.push({ value: "", type: "string" });
  data.push(line);

  line = [];
  line.push({ value: t("csv.module"), type: "string" });
  line.push({ value: t("csv.el"), type: "string" });
  line.push({ value: t("csv.el") + " ID", type: "string" });
  line.push({ value: t("csv.code"), type: "string" });
  data.push(line);

  vendorProfiles.forEach((profile) => {
    line = [];
    line.push({ value: t("admin.common.exp"), type: "string" });
    line.push({ value: profile.name, type: "string" });
    line.push({ value: profile.id, type: "string" });
    line.push({ value: profile.id, type: "string" });
    data.push(line);
  });

  products.forEach((product) => {
    let group = "";
    if (product.group_id) {
      group = groups.find((group) => group.id === product.group_id).descriptive_name;
    }

    line = [];
    line.push({ value: selectTextByLanguage(group, lng, languages), type: "string" });
    line.push({ value: selectTextByLanguage(product.name, lng, languages), type: "string" });
    line.push({ value: product.id, type: "string" });
    line.push({ value: selectTextByLanguage(product.name, lng, languages), type: "string" });
    data.push(line);
  });

  let xlsxFile = {
    filename: t("csv.elFileName"),
    sheet: {
      data: data,
    },
  };
  zipcelx(xlsxFile);
};

export const parseInvitationCsv = (csvString, callback) => {
  let data = Papa.parse(csvString, {
    header: true,
    skipEmptyLines: true,
    delimiter: ";",
  });

  callback(data.data);
};
export const validateAndJoinInvitationsByUser = (rows, products, groups, vendorProfiles, vendorId, companyId, vendorLanguages, languages, t) => {
  const invitations = [];

  let columnMapping;

  const mappingTest = languages.some((lng) => {
    columnMapping = prepareColumnMapping(lng);
    let EMAIL = rows[0][columnMapping['EMAIL']];
      return EMAIL !== undefined;
  });

  if (!mappingTest) {
    console.info("Email column not found in any language");
  }

  rows.forEach((row) => {
    let {
      [columnMapping['EMAIL']]: EMAIL,
      [columnMapping['ORDER_NUMBER']]: ORDER_NUMBER,
      [columnMapping['NAME']]: NAME,
      [columnMapping['SURNAME']]: SURNAME,
      [columnMapping['LANGUAGE']+' '+languagesToString(vendorLanguages)]: LANGUAGE,
      [columnMapping['REVIEW_ITEM']]: REVIEW_ITEM,
    } = row;

    if(!LANGUAGE) LANGUAGE = Object.values(row)[5];
    if(!NAME) NAME = Object.values(row)[0];
    if(!SURNAME) SURNAME = Object.values(row)[1];
    if(!EMAIL) EMAIL = Object.values(row)[2];
    if(!REVIEW_ITEM) REVIEW_ITEM = Object.values(row)[3];
    if(!ORDER_NUMBER) ORDER_NUMBER = Object.values(row)[4];
    
    // Find an existing invitation to edit based on email and order number
    const invitationToEdit = invitations.find((invitation) => invitation.customerEmail === EMAIL && invitation.orderNumber === ORDER_NUMBER);

    let invitation;

    if (!invitationToEdit) {
      invitation = {
        customerEmail: getTrimedCellValue(EMAIL),
        purchaseDateUtcMs: moment().format("x"),
        customerName: getTrimedCellValue(NAME),
        customerSurname: getTrimedCellValue(SURNAME),
        reviewProfile: false,
        orderNumber: getTrimedCellValue(ORDER_NUMBER),
        products: [],
        vendorId: vendorId,
        validationErrors: validateRow(row, companyId, vendorProfiles, products, vendorLanguages , languages, t),
        language: getTrimedCellValue(LANGUAGE),
      };
    } else {
      invitation = invitationToEdit;
    }


    const vendorProfile = vendorProfiles.find(profile => equalsNoSpaceIgnoreCase(profile.id, REVIEW_ITEM) || equalsNoSpaceIgnoreCase(profile.name, REVIEW_ITEM));

    if (vendorProfile && !invitation.profileId) {
      invitation.profileId = REVIEW_ITEM;
      invitation.reviewProfile = true;
    }

    if (invitationToEdit) {
      const index = invitations.indexOf(invitationToEdit);
      invitations.splice(index, 1);
    }

    const vendorProduct = products.find((product) => equalsNoSpaceIgnoreCase(product.source_id, REVIEW_ITEM) || equalsNoSpaceIgnoreCase(product.nametoshow, REVIEW_ITEM));


    if (vendorProduct) {
      const productGroup = groups.find((group) => vendorProduct.groupId === group.id);
      const product = {
        sourceId: vendorProduct.source_id,
        imgUrl: vendorProduct.imgUrl,
        name: vendorProduct.name,
        group: productGroup ? productGroup.name : "",
        nametoshow: vendorProduct.nametoshow,
      };
      invitation.products.push(product);
    }

    invitations.push(invitation);
  });

  return invitations;
};

export const validateRow = (row, companyId, vendorProfiles, products, vendorLanguages, languages, t) => {

  let columnMapping;

  const mappingTest = languages.some((lng) => {
    columnMapping = prepareColumnMapping(lng);
    let EMAIL = row[columnMapping['EMAIL']];
      return EMAIL !== undefined;
  });

  if (!mappingTest) {
    console.info("Email column not found in any language");
  }

  let {
    [columnMapping['EMAIL']]: EMAIL,
    [columnMapping['ORDER_NUMBER']]: ORDER_NUMBER,
    [columnMapping['NAME']]: NAME,
    [columnMapping['SURNAME']]: SURNAME,
    [columnMapping['LANGUAGE']+' '+ languagesToString(vendorLanguages)]: LANGUAGE,
    [columnMapping['REVIEW_ITEM']]: REVIEW_ITEM,
  } = row;

    if(!LANGUAGE) LANGUAGE = Object.values(row)[5];
    if(!NAME) NAME = Object.values(row)[0];
    if(!SURNAME) SURNAME = Object.values(row)[1];
    if(!EMAIL) EMAIL = Object.values(row)[2];
    if(!REVIEW_ITEM) REVIEW_ITEM = Object.values(row)[3];
    if(!ORDER_NUMBER) ORDER_NUMBER = Object.values(row)[4];

  let validationErrors = {};

  if (!validator.isEmail(EMAIL)  && !validator.isMobilePhone(EMAIL, "any") ) {
    validationErrors.customerEmail = t("csv.err.email");
  }
  if (!SURNAME.toString().trim()) {
    validationErrors.customerSurname = t("csv.err.sur");
  }
  if (!NAME.toString().trim()) {
    validationErrors.customerName = t("csv.err.name");
  }

  if (vendorProfiles.filter((profile) => equalsNoSpaceIgnoreCase(profile.id, REVIEW_ITEM) || equalsNoSpaceIgnoreCase(profile.name, REVIEW_ITEM)).length === 0 &&
    products.filter((product) => equalsNoSpaceIgnoreCase(product.source_id, REVIEW_ITEM) || equalsNoSpaceIgnoreCase(product.nametoshow, REVIEW_ITEM)).length === 0) {
    validationErrors.reviewElement = t("csv.err.el");
  }


  if (!languages.includes(LANGUAGE)) {
    validationErrors.language = t("csv.err.lng");
  }


  return validationErrors;
};

export const getTrimedCellValue = (cellValue) => {
  return cellValue ? cellValue.trim() : "";
};

export const equalsNoSpaceIgnoreCase = (value1, value2) => {
  // Check if both values are strings
  if (typeof value1 !== 'string' || typeof value2 !== 'string') return false;

  // Return comparison result after removing spaces and converting to lowercase
  return value1.replace(/\s+/g, '').toLowerCase() === value2.replace(/\s+/g, '').toLowerCase();
};

